import React from 'react';
import { CardElement } from '@stripe/react-stripe-js';
import { Lock } from 'lucide-react';

const CARD_ELEMENT_OPTIONS = {
  style: {
    base: {
      fontSize: '16px',
      fontFamily: 'Inter, system-ui, sans-serif',
      color: '#374151',
      '::placeholder': {
        color: '#9CA3AF',
      },
    },
    invalid: {
      color: '#EF4444',
      iconColor: '#EF4444',
    },
  },
  hidePostalCode: true,
};

interface CreditCardFormProps {
  error?: string | null;
}

export default function CreditCardForm({ error }: CreditCardFormProps) {
  return (
    <div className="bg-white p-6 rounded-lg shadow-sm mb-6">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-xl font-semibold">Payment Information</h2>
        <div className="flex items-center text-gray-500">
          <Lock className="w-4 h-4 mr-1" />
          <span className="text-sm">Secure Payment</span>
        </div>
      </div>
      
      <div className="space-y-6">
        <div className="p-4 border rounded-md bg-white">
          <CardElement options={CARD_ELEMENT_OPTIONS} />
        </div>
        
        {error && (
          <div className="text-red-600 text-sm bg-red-50 p-3 rounded-md">
            {error}
          </div>
        )}

        <div className="flex items-start space-x-2 text-sm text-gray-500">
          <Lock className="w-4 h-4 mt-0.5 flex-shrink-0" />
          <p>
            Your payment is secured by Stripe. We never store your card details.
          </p>
        </div>
      </div>
    </div>
  );
}